import React from "react";

export default function SQL_AS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_AS</h1>
      <p>This is the SQL_AS component generated from the SQL JSON.</p>
    </div>
  );
}
